//src/Components/Buttons/UploadDocumentButton/index.tsx
import { PaperClipIcon } from 'assets/icons';
import { ChangeEvent } from 'react';

export default function UploadDocumentButton({
  onChange = ([]) => {},
  disabled = false,
}: {
  disabled?: boolean;
  onChange: (files: File[]) => void;
}) {
  const handleFileInput = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;
    onChange(Array.from(event.target.files));
    /* disable browser input file caching - 
      it stores last uploaded file name as a string,
      not useful when uploading multiple */
    event.target.value = '';
  };

  return (
    <label className="cursor-pointer px-2 py-1  mr-2 mb-1.5 shadow  flex justify-center items-center p-1 focus:outline-none focus:ring focus:ring-offset-1 text-gray-700 focus:text-green hover:text-green focus:ring-green rounded ">
      <PaperClipIcon className="w-auto  h-5 text-green" />

      <input
        disabled={disabled}
        multiple
        type="file"
        accept=".odt, .ods, .doc, .docx, .txt, .xls, .pdf, .png, .tif, .gif, .xlsx, .jpeg, .csv, .xlsm"
        name={'nsa'}
        className="hidden"
        onChange={handleFileInput}
      />
    </label>
  );
}
